<template>
  <v-dialog
    v-model="isDialog"
    width="500">
    <v-card>
      <v-form ref="batchCreate">
        <v-date-picker
          v-model="month"
          :allowed-dates="allowedDates"
          :locale="locale"
          full-width
          flat
          no-title
          type="month"/>
      </v-form>

      <v-card-actions>
        <v-checkbox
          v-if="isCurrentMonth"
          v-model="ignoreLastSixDays"
          :label="$t('ignore_last_6_days')"
          hide-details
          class="ma-1"/>
        <v-spacer/>
        <disabled-user-button>
          <v-btn
            slot-scope="{isDisabledForUser}"
            :disabled="isDisabledForUser || isLoading"
            :loading="isLoading"
            color="primary"
            @click.native="submit"
          >
            {{ $t('create') }}
          </v-btn>
        </disabled-user-button>
      </v-card-actions>
    </v-card>

    <template slot="activator">
      <v-btn
        color="primary"
        class="ml-2">{{ $t('submit') }}</v-btn>
    </template>
  </v-dialog>
</template>

<script>
import DatePicker from '@/components/global-components/inputs/DatePicker'
import MonthPicker from '@/components/global-components/inputs/MonthPicker'
import DisabledUserButton from '@/components/global-components/disabledUserButton/disabledUserButton'

import { mapGetters } from 'vuex'

export default {
  name: 'TimesheetBatchOneMonthMultipleEmployees',
  components: { DisabledUserButton, MonthPicker, DatePicker },
  props: ['employees'],
  data () {
    return {
      isDialog: false,
      month: '',
      isLoading: false,
      ignoreLastSixDays: false,
      lastDayOfCalculation: this.$moment().daysInMonth()
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee']),
    schemas () {
      return this.employees.map(employee => employee.schema_id).toString()
    },
    locale () {
      return `${localStorage.locale}-${localStorage.locale}`
    },
    isCurrentMonth () {
      return this.month === this.$moment().format('YYYY-MM')
    }
  },
  methods: {
    async submit () {
      if (this.ignoreLastSixDays && this.isIgnoreLastSixDays) this.lastDayOfCalculation = this.$moment().subtract(6, 'day').format('YYYY-MM-DD')

      const month = this.$moment(this.month, 'YYYY-MM').format('MM-YYYY')
      const query = { schemas: this.schemas, month, multiEmployees: true, ignore_last_6_days: this.ignoreLastSixDays, lastDayOfCalculation: this.lastDayOfCalculation }

      this.$router.push({ name: 'timesheetBatchEdit', query })
    },
    allowedDates (value) {
      const $date = this.$moment(value, 'YYYY-MM')
      const $now = this.$moment()
      if ($date.isSame($now, 'month') && this.ignoreLastSixDays && $now.date() <= 6) {
        if (this.month === $now.format('YYYY-MM')) {
          this.month = ''
        }
        return false
      }
      return $date.endOf('month').diff($now.endOf('month'), 'days') <= 0
    }
  },
  watch: {
    isDialog () {
      this.month = ''
    }
  },
  i18n: {
    messages: {
      en: {
        create: 'Download',
        submit: 'Create time sheets',
        ignore_last_6_days: 'Ignore last 6 days'
      },
      tr: {
        create: 'İndir',
        submit: 'Zaman çizelgesi tanımla',
        ignore_last_6_days: 'Son 6 günü yoksay'
      },
      de: {
        create: 'Download',
        submit: 'Stundenzettel erstellen',
        ignore_last_6_days: 'Letzte 6 Tage ignorieren'
      },
      ru: {
        create: 'Загрузить',
        submit: 'Создать табели',
        ignore_last_6_days: 'Игнорировать последние 6 дней'
      }
    }
  }
}
</script>
